export default [
  "canon_d",
  "fortree_city",
  "serenade",
  "serene",
  "sleep",
  "symphony_no_5",
  "timelapse",
  "waves_of_happiness",
  "you_are_already_dead",
];